export default __webpack_public_path__ + "static/media/4-france_skiing.5ac30065.jpg";